import {
  Bell,
  RefreshCw,
  MessageSquare,
  Languages,
  Brain,
  Scan
} from "lucide-react";
import { MarktingCard } from "../../AvatarDigitalMarketer/AiMarketingTeam";
import Box from "../../components/Box";

export const features = [
  {
    icon: <Bell className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Personalized Updates",
    description: "Attendance, exams, homework, fees, PTMs — every message is made for the child and family."
  },
  {
    icon: <RefreshCw className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "360° Progress Feedback",
    description: "We study marks, attendance, teacher notes and behaviour to give an all-round report with next steps."
  },
  {
    icon: <MessageSquare className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "AI Tutor in WhatsApp",
    description: "24×7 smart tutor that guides students step-by-step and builds thinking skills, not memorization."
  },
  {
    icon: <Languages className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Multilingual & Simple",
    description: "Messages are written in parent-friendly language. 10+ Indian languages supported. Multilingual updates coming soon."
  },
  {
    icon: <Brain className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Emotional Intelligence",
    description: "Messages include encouragement and practical tips, not only scores and alerts."
  },
  {
    icon: <Scan className="w-6 h-6" />,
    iconBg: "bg-blue-100",
    iconColor: "text-[#4949DE]",
    title: "Automatic, Low Cost",
    description: "Runs inside WhatsApp — no extra app for parents. Affordable subscription. Saves teacher time."
  }
];


export default function Keyfeatures() {

  return (
    <Box
      badge={"Features"}
      title={"Key Features"}
      leftBlock={
        <div className='col-span-2 md:col-span-1'>
          <div className="grid grid-cols-3 md:grid-cols-1 gap-6">
            {features.map((member, index) => <MarktingCard key={"Keyfeatures" + index} member={member} />)}
          </div>
        </div>
      }
    />
  );
}